import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { DebounceTrigger } from '../../models/debounce-trigger.model';

@Component({
    selector: 'spv2-grid-search',
    templateUrl: './grid-search.component.html',
    styleUrls: ['./grid-search.component.scss'],
    standalone: false
})
export class GridSearchComponent implements OnInit {

  @Input() filter: string;
  @Output() filterChange = new EventEmitter<string>();

  showFilter = false;
  searchTrigger = new DebounceTrigger(() => this.triggerSearch(), 700);

  constructor() { }

  ngOnInit(): void {
  }
  
  toggleFilter() {
    this.showFilter = !this.showFilter;
  }

  triggerSearch() {
    this.filterChange.emit(this.filter)
  }
}
